import { useEffect, useRef } from 'react'

import useAcquiredModelOpener from 'Pods/LazyLoaded/ThreeDModelPicker/Hooks/useAcquiredModelOpener'
import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'

const ITEM_ID_PARAM = 'item_id'

// Opens a model the user already owns straight in the viewer, for the "Edit with AI"
// action in My Purchases (`/ai?item_id=123`). Same client-side param read as
// useDeepLinkGeneration: this page is cached HTML served by FastApplicationController and
// the SSR StaticRouter never sees the query string, so the id cannot come from SSR props.
// The param is stripped afterwards so a refresh or a share does not re-open the model.
const useDeepLinkAcquiredModel = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { openModel } = useAcquiredModelOpener()
  const appliedRef = useRef(false)

  const search = location?.search ?? ''

  useEffect(() => {
    if (appliedRef.current) return

    const params = new URLSearchParams(search)
    const itemId = params.get(ITEM_ID_PARAM)

    if (!itemId) return

    // Flipped before openModel rather than after it, unlike useDeepLinkGeneration: the
    // open is asynchronous, so a re-render between the call and its resolution would
    // otherwise start a second prepare request for the same model.
    appliedRef.current = true

    params.delete(ITEM_ID_PARAM)
    const nextSearch = params.toString()

    navigate(
      { pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '' },
      { replace: true, state: location.state }
    )

    openModel(itemId)
  }, [search, location.pathname, location.state, navigate, openModel])
}

export default useDeepLinkAcquiredModel
